import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import Input from "../../common/Input";

import * as Constants from "../../../helpers/Constants";
import * as ConfigActions from "../../actions/Config";
import * as CommunityActions from "../../actions/Communities";
import * as Strings from "./strings";

class CreateCorporationModal extends Component {
  state = {
    apartmentsNumber: "",
    apartmentsAddress: ""
  };

  componentDidMount() {
    const { communities, id } = this.props;
    const community = communities.data.find(c => c.id === id);
    const privileges = community.privileges
      ? community.privileges
      : community.privilege;

    this.setState({ ...community, ...privileges });
  }

  componentDidUpdate(prevProps) {
    const { communities, onClose } = this.props;

    if (prevProps.communities.isUpdating && !communities.isUpdating) {
      if (!communities.errorUpdating) {
        onClose();
        this.props.showSnackbar(Strings.default.CORPORATION_UPDATED);
      } else {
        this.setState({ errorMessage: Strings.default.INTERNAL_ERROR });
      }
    }
  }

  updateCorporation() {
    const { user, id } = this.props;
    const {
      name,
      emailAddress,
      phoneNumber,
      address,
      postalNumber,
      firstName,
      lastName,
      city,
      orgNumber,
      price,
      janitor,
      laundryBookingSystem,
      errorReportSystem,
      feedSystem,
      infoSystem,
      bookingSystem,
      apartments,
      password
    } = this.state;

    this.setState({ errorMessage: "" });

    if (name === "") {
      this.setState({ errorName: Strings.default.MANDATORY_FIELD });
    }

    if (emailAddress === "") {
      this.setState({ errorEmailAddress: Strings.default.MANDATORY_FIELD });
    }

    if (janitor === "") {
      this.setState({ errorJanitor: Strings.default.MANDATORY_FIELD });
    }

    if (name !== "" && emailAddress !== "" && janitor !== "") {
      const data = {
        community: {
          name,
          emailAddress,
          phoneNumber,
          address,
          postalNumber,
          firstName,
          lastName,
          city,
          orgNumber,
          price,
          janitor
        },
        privilege: {
          laundryBookingSystem,
          errorReportSystem,
          feedSystem,
          infoSystem,
          bookingSystem
        },
        user: {
          emailAddress,
          phoneNumber
        },
        apartments: []
      };

      if (password && password !== "") {
        data.user.password = password;
      }

      // do update Community
      this.props.tryUpdateCommunity(user.token, id, data);
    }
  }

  createAppartment() {
    console.log('createAppartment');
    const { user, id } = this.props;
    const { apartmentsAddress, apartmentsNumber} = this.state;

    if (apartmentsAddress === "") {
      this.setState({ errorAppartmentAddress: Strings.default.MANDATORY_FIELD });
    }
    if (apartmentsNumber === "") {
      this.setState({ errorAppartmentNumber: Strings.default.MANDATORY_FIELD });
    }
    if (apartmentsAddress !== "" && apartmentsNumber !== "") {
      // the apartmentsAddress and apartmentsNumber needs to be set in the const data as address and number

      const data = {
        address: apartmentsAddress,
        number: apartmentsNumber
      };
      // do appartment creation
      this.props.tryCreateAppartment(user.token, id, data).then(() => {
        this.fetchCommunities(user.token);
        this.setState({
          apartmentsAddress: "",
          apartmentsNumber: ""
        });
      });
    }
  }

  deleteAppartment(appartmentId) {
    const { user, id } = this.props;
    // do appartment deletion
    this.props.tryDeleteAppartment(user.token, id, appartmentId).then(() => {
      this.fetchCommunities(user.token);
    });
  }

  fetchCommunities() {
    const { history, user } = this.props;

    if (!user.token) {
      history.push("/");
    } else {
      this.props.tryGetCommunities(user.token);
      this.forceUpdate();
    }
  }

  render() {
    const { config, classes, communities, onClose, id } = this.props;

    const {
      name,
      emailAddress,
      phoneNumber,
      address,
      postalNumber,
      firstName,
      lastName,
      city,
      orgNumber,
      price,
      janitor,
      laundryBookingSystem,
      errorReportSystem,
      feedSystem,
      infoSystem,
      bookingSystem,
      apartmentsAddress,
      apartmentsNumber,
      password = "",
      errorPassword,
      errorMessage,
      errorName,
      errorEmailAddress,
      errorJanitor,
      errorAppartmentAddress,
      errorAppartmentNumber
    } = this.state;

    const community = communities.data.find(c => c.id === id);

    return (
      <Dialog
        open={true}
        aria-labelledby={"form-dialog-title"}
        onClose={() => onClose()}
        maxWidth={"xl"}
      >
        <div style={{ width: "80vw" }}></div>
        <DialogTitle id={"form-dialog-title"}>
          {Strings.default.NEW_CORPORATION}
        </DialogTitle>
        <DialogContent>
          {errorMessage === "" ? null : (
            <p style={{ fontSize: 12, color: "#e57373" }}>{errorMessage}</p>
          )}
          <Input
            onChange={text => this.setState({ name: text, errorName: "" })}
            value={name}
            placeholder={Strings.default.CORPORATION_NAME + "*"}
            error={errorName}
          />
          <Input
            onChange={text => this.setState({ orgNumber: text })}
            value={orgNumber}
            placeholder={Strings.default.ORG_NUMBER}
          />
          <Input
            onChange={text =>
              this.setState({
                emailAddress: text,
                errorEmailAddress: ""
              })
            }
            value={emailAddress}
            placeholder={Strings.default.BILLING_AND_PHONE_EMAIL + "*"}
            error={errorEmailAddress}
          />
          <Input
            onChange={text => this.setState({ password: text, errorPassword: "" })}
            value={password}
            placeholder={Strings.default.PASSWORD}
            error={errorPassword}
          />
          <Input
            onChange={text =>
              this.setState({
                janitor: text,
                errorJanitor: ""
              })
            }
            value={janitor}
            placeholder={Strings.default.JANITOR + "*"}
            error={errorJanitor}
          />
          <Input
            onChange={text => this.setState({ phoneNumber: text })}
            value={phoneNumber}
            placeholder={Strings.default.CONTACT_NUMBER}
          />
          <Input
            onChange={text => this.setState({ firstName: text })}
            value={firstName}
            placeholder={Strings.default.CONTACT_FIRST_NAME}
          />
          <Input
            onChange={text => this.setState({ lastName: text })}
            value={lastName}
            placeholder={Strings.default.CONTACT_LAST_NAME}
          />
          <Input
            onChange={text => this.setState({ address: text })}
            value={address}
            placeholder={Strings.default.ADDRESS}
          />
          <Input
            onChange={text => this.setState({ postalNumber: text })}
            value={postalNumber}
            placeholder={Strings.default.ZIP_CODE}
          />
          <Input
            onChange={text => this.setState({ city: text })}
            value={city}
            placeholder={Strings.default.CITY}
          />
          <Input
            onChange={text => this.setState({ price: text })}
            value={price}
            placeholder={Strings.default.PRICE}
          />
          <DialogContentText>Tjänster</DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={laundryBookingSystem}
                onChange={() =>
                  this.setState({ laundryBookingSystem: !laundryBookingSystem })
                }
              />
            }
            label="Tvättbokning"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={errorReportSystem}
                onChange={() =>
                  this.setState({ errorReportSystem: !errorReportSystem })
                }
              />
            }
            label="Felanmälan"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={feedSystem}
                onChange={() => this.setState({ feedSystem: !feedSystem })}
              />
            }
            label="Flöde"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={infoSystem}
                onChange={() => this.setState({ infoSystem: !infoSystem })}
              />
            }
            label="Information"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={bookingSystem}
                onChange={() =>
                  this.setState({ bookingSystem: !bookingSystem })
                }
              />
            }
            label="Övrig bokning"
          />
          <DialogContentText>Lägenheter</DialogContentText>
          <Table className={classes.table} aria-labelledby={"tableTitle"}>
            <TableHead>
              <TableRow>
                <TableCell>Adress</TableCell>
                <TableCell>Lägenhetsnummer</TableCell>
                <TableCell>Lägenhetskod</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {community.apartments.map(item => {
                return (
                  <TableRow key={item.id} className={classes.row}>
                    <TableCell>{item.address}</TableCell>
                    <TableCell>{item.number}</TableCell>
                    <TableCell>{item.code}</TableCell>
                    <TableCell style={{ textAlign: "center", width: "1%" }}>
                      <FontAwesomeIcon
                        icon={faTrash}
                        color={"#e57373"}
                        onClick={() => {
                          this.props.showAlert(
                            "Ta bort Lägenhet",
                            "Är du säker på att du vill ta bort Lägenhet? Detta kan inte göras ogjort.",
                            Constants.TWO_BUTTONS,
                            { title: "Nej", onPress: () => {} },
                            {
                              title: "Ja",
                              onPress: () =>
                                this.deleteAppartment(item.id)
                            }
                          );
                        }}
                        style={{ fontSize: 18, cursor: "pointer" }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell>
                  <Input
                    onChange={text =>
                      this.setState({
                        apartmentsAddress: text,
                        errorAppartmentAddress: ""
                      })
                    }
                    value={apartmentsAddress}
                    placeholder={Strings.default.ADDRESS}
                    error={errorAppartmentAddress}
                  />
                </TableCell>
                <TableCell>
                  <Input
                    onChange={text =>
                      this.setState({
                        apartmentsNumber: text,
                        errorAppartmentNumber: ""
                      })
                    }
                    value={apartmentsNumber}
                    placeholder={Strings.default.APPARTMENT_NUMBER}
                    error={errorAppartmentNumber}
                  />
                </TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Button
                    onClick={() => this.createAppartment()}
                    classes={{ label: classes.successButtonText }}
                  >
                    {Strings.default.CREATE_APPARTMENT}
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
        {communities.isCreating ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: "#289e64" }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => onClose()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => this.updateCorporation()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.UPDATE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

const Styles = {
  successButtonText: {
    color: "#289e64"
  },
  warningButtonText: {
    color: "#e57373"
  },
  table: {
    minWidth: 700
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fafafa"
    }
  }
};

function mapStateToProps({ user, config, communities }) {
  return { user, config, communities };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...ConfigActions, ...CommunityActions },
    dispatch
  );
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CreateCorporationModal);



// WEBPACK FOOTER //
// ./src/components/containers/UpdateCorporationModal/index.js